import { PLAN_TYPE, PlanType } from "@/constants";
import { FEATURE, FeatureType } from "@/features";

export type FrontendPlan = {
  type: PlanType;
  name: string;
  description: string;
  price_string: string;
  price_extra?: string;
  price_legal?: string;
  price_string_monthly?: string;
  feature_title?: string;
  accent?: string; // color

  features: Array<{
    required_feature?: FeatureType;
    name: string;
  }>;
};

export const free: FrontendPlan = {
  type: PLAN_TYPE.FREE,
  name: L.FREE_PLAN_NAME,
  description: L.FREE_PLAN_DESCRIPTION,
  price_string: L.FREE_PLAN_PRICE,
  feature_title: L.FREE_PLAN_FEATURE_LIST_TITLE,
  features: [
    {
      name: L.FREE_PLAN_FEATURE_1,
    },
    {
      name: L.FREE_PLAN_FEATURE_2,
    },
    {
      name: L.FREE_PLAN_FEATURE_3,
    },
    {
      name: L.FREE_PLAN_FEATURE_4,
    },
  ],
};

export const basic: FrontendPlan = {
  accent: "var(--pink-900)",
  type: PLAN_TYPE.BASIC,
  name: L.BASIC_PLAN_NAME,
  description: L.BASIC_PLAN_DESCRIPTION,
  price_string: L.BASIC_PLAN_PRICE,
  price_string_monthly: L.BASIC_PLAN_MONTHLY_PRICE,
  price_extra: L.BASIC_PLAN_PRICE_EXTRA,
  price_legal: L.BASIC_PLAN_PRICE_LEGAL,
  feature_title: L.BASIC_PLAN_FEATURE_LIST_TITLE,
  features: [
    {
      name: L.BASIC_PLAN_FEATURE_1,
      required_feature: FEATURE.HAS_SEARCH_PRODUCT,
    },
    {
      name: L.BASIC_PLAN_FEATURE_2,
      required_feature: FEATURE.HAS_SEARCH_PRODUCT,
    },
    {
      name: L.BASIC_PLAN_FEATURE_3,
      required_feature: FEATURE.HAS_REPORT_PRODUCT,
    },
    {
      name: L.BASIC_PLAN_FEATURE_4,
    },
    {
      name: L.BASIC_PLAN_FEATURE_5,
    },
    {
      name: L.BASIC_PLAN_FEATURE_6,
    },
  ],
};

export const custom: FrontendPlan = {
  accent: "var(--blue-700)",
  type: PLAN_TYPE.CUSTOM,
  name: L.CUSTOM_PLAN_NAME,
  description: L.CUSTOM_PLAN_DESCRIPTION,
  feature_title: L.CUSTOM_PLAN_FEATURE_LIST_TITLE,
  price_string: L.CUSTOM_PLAN_PRICE,
  features: [
    {
      name: L.CUSTOM_PLAN_FEATURE_1,
      required_feature: FEATURE.HAS_SEARCH_PRODUCT,
    },
    {
      name: L.CUSTOM_PLAN_FEATURE_2,
      required_feature: FEATURE.DISPLAY_INSIGHTS,
    },
    {
      name: L.CUSTOM_PLAN_FEATURE_3,
      required_feature: FEATURE.HAS_REPORT_PRODUCT,
    },
    {
      name: L.CUSTOM_PLAN_FEATURE_4,
      required_feature: FEATURE.HAS_EXCEL_EXPORT_FEATURE,
    },
    {
      name: L.CUSTOM_PLAN_FEATURE_5,
      required_feature: FEATURE.HAS_RSS_FEATURE,
    },
    {
      name: L.CUSTOM_PLAN_FEATURE_6,
      required_feature: FEATURE.HAS_REPORT_PRODUCT,
    },
    {
      name: L.CUSTOM_PLAN_FEATURE_7,
    },
    {
      name: L.CUSTOM_PLAN_FEATURE_8,
    },
  ],
};
